export default "__VITE_ASSET__CwkHF7lk__"